<template>
    <div class>
        <div class="page-cnt">
            <!-- Left sidebar -->
            <div class="left-sidebar">
                <search-tour v-on:updateSameTour="updateSameTour"></search-tour>
                <div class="notify-box" v-if="isNotify">
                    <div class="header">
                        <i class="icon-notify"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="body">
                        <div class="title">
                            {{ infos.title }}
                        </div>
                        <div v-html="infos.body"></div>
                    </div>
                </div>
                <div class="notify-box" v-else>
                    <div class="no-show-header">
                        <i class="icon-notify-no-show"></i>
                        <div class="notify-title">{{$t('notify.title')}}</div>
                    </div>
                    <div class="no-show-body">
                        {{$t('notify.no-show')}}
                    </div>
                </div>
                <div class="login-info-box" v-if="user">
                    <div class="login-info pb-2">
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3">{{$t('login_info.last_login_date')}}</div>
                            <div class="col-7 pl-1">{{user.last_login}}</div>
                        </div>
                        <div class="row no-gutters mt-2">
                            <div class="col-5 pl-3">{{$t('login_info.last_update_pass_date')}}</div>
                            <div class="col-7 pl-1">{{user.last_update_pass_time}}</div>
                        </div>
                    </div>
                </div>

                <div class="mt-3 text-center">
                    操作方法などわからないことあれば<br>
                    <a :href="$t('chatbot.url')" target="_blank">証憑類電子化チャットボット</a>へ
                </div>
            </div>
            <!-- /Left sidebar -->

            <!-- Main content -->
            <div class="main-cnt">
                <div class="content-white">
                    <tour-info :tourInfoProp="tourInfo"></tour-info>
                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                        <a v-show="isNotTour" @click="setIsClosed" href="#" style="float:right;">締切済ツアーも対象として再検索</a>
                    </div>
                    <div class="content-body">
                        <div class="box-content">
                            <div class="row h-100">
                                <div v-if="listCash[0]" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 h-100">
                                    <div class="d-flex" style="justify-content: space-between;">
                                        <button v-if="this.cashId" class="btn btn-pink-53 w140 mr-3" @click="toCashList">OK</button>
                                        <div v-else class="btn btn-gray-53 w140 mr-3">OK</div>
                                        <InputT
                                            v-if="utils.isCooperator()"
                                            v-model="selectedInputT"
                                        />
                                    </div>

                                    <div class="block-cnt">
                                        <div class="heading-box">{{$t('cash.select_from_list')}}</div>
                                        <div class="scroll-list">
                                            <div v-if="selectedInputT.id === 1 && utils.isCooperator()" v-for="(element, index) in ownListCash" :key="index" class="table-detail">
                                                <div
                                                    class="detail-block"
                                                    :class="{'ex-block-heading': activeCash === index}"
                                                    @click="clickCash(element.carrying_prepayment_item_id, index, element.name)"
                                                    name="index"
                                                >
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.name')}}</label>
                                                        <div class="row-cnt">{{element.name}}</div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.period')}}</label>
                                                        <div class="row-cnt">
                                                            {{dateUtils.formatDateYYYYMMDD(element.days_from)}}({{dateUtils.getDay(element.days_from)}})〜
                                                            {{dateUtils.formatDateYYYYMMDD(element.days_to)}}({{dateUtils.getDay(element.days_to)}})
                                                        </div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.total_amount_pc')}}</label>
                                                        <div
                                                            class="row-cnt"
                                                        >{{utils.formatPrice(element.total_deposit, currencyId)}}{{getCurrencyName(currencyId)}}</div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.notice_c')}}</label>
                                                        <div class="row-cnt">{{element.notice_c}}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="selectedInputT.id === 2 || !utils.isCooperator()" v-for="(element, index) in listCash" :key="index" class="table-detail">
                                                <div
                                                    class="detail-block"
                                                    :class="{'ex-block-heading': activeCash === index}"
                                                    @click="clickCash(element.carrying_prepayment_item_id, index, element.name)"
                                                    name="index"
                                                >
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.name')}}</label>
                                                        <div class="row-cnt">{{element.name}}</div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.period')}}</label>
                                                        <div class="row-cnt">
                                                            {{dateUtils.formatDateYYYYMMDD(element.days_from)}}({{dateUtils.getDay(element.days_from)}})〜
                                                            {{dateUtils.formatDateYYYYMMDD(element.days_to)}}({{dateUtils.getDay(element.days_to)}})
                                                        </div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.total_amount_pc')}}</label>
                                                        <div
                                                            class="row-cnt"
                                                        >{{utils.formatPrice(element.total_deposit, currencyId)}}{{getCurrencyName(currencyId)}}</div>
                                                    </div>
                                                    <div class="block-row">
                                                        <label class="row-lb">{{$t('cash.notice_c')}}</label>
                                                        <div class="row-cnt">{{element.notice_c}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Main content -->
        </div>
    </div>
</template>

<script>
import TourInfo from "@/views/layout/pc/Tour/Info";
import SearchTour from "@/views/layout/pc/Tour/Search";
import TourManagementService from "@/services/module/tour.service";
import CashManagementService from "@/services/module/cash.service";
import { AuthService } from "@/services/common/auth.service";
import InfoService from '@/services/admin/infos.service';
import { TheMask } from "vue-the-mask";
import StorageService from "@/services/common/storage.service";
import Utils from "@/helpers/utils";
import DateUtils from "@/helpers/dateUtils";
import { Constants } from "@/helpers/constants";
import  InputT  from "@/views/components/pc/Tour/InputT";
export default {
    components: {
        TheMask,
        TourInfo,
        SearchTour,
        InputT,
    },
    name: "PcSearchTour",
    data () {
        const storageUser = JSON.parse(StorageService.getUser());
        let user = null;
        if (storageUser) {
            const last_login = storageUser.last_login ? storageUser.last_login.replace(/-/g, '/') : '';
            const last_update_pass_time = storageUser.last_update_pass_time ? storageUser.last_update_pass_time.replace(/\./g, '/') : '';
            const userInfo = {
                last_login: last_login,
                last_update_pass_time: last_update_pass_time
            }
            user = userInfo;
        }
        return {
            utils: Utils,
            dateUtils: DateUtils,
            constants: Constants,
            keyword_search: "",
            tourInfo: {},
            listCash: [],
            ownListCash: [],
            masked: true,
            activeCash: "",
            cashId: "",
            errorMessage: "",
            currencyId: Constants.JPY.id,
            user: user,
            isNotify: false,
            infos: {},
            isClosed: 0,
            isNotTour: false,
            selectedInputT: Constants.InputT[0],
            userCashKeyName: "",
        };
    },
    created () {
        this.userCashKeyName = StorageService.getUserCashKeyName();
        let tourNumber = this.$route.query.search;
        let isClosed = this.$route.query.isClosed;
        if (tourNumber) {
            this.getTourInfo(tourNumber, isClosed);
            this.keyword_search = tourNumber;
        } else {
            this.removeTourCash();
        }
    },
    mounted () {
        InfoService.getInfo().then(response =>{
            if (response.status == 423) {
                StorageService.saveExpired();
                AuthService.doLogout();
            }
            if (response.status == 200) {
                this.infos = response.data;
                if (this.infos) {
                    this.isNotify = this.infos.is_notify;
                    // this.infos.body = (this.infos.body).replace(/n/g, '<br>');
                } else {
                    this.isNotify = false;
                }
            }
        })
    },
    watch: {
        'infos.body' : function () {
            this.infos.body = (this.infos.body).replace(/\n/g, '<br>');
        },
    },
    methods: {
        getCurrencyName (id) {
            let name = Utils.getCurrencyName(id);
            return name;
        },
        getCashInfo (tourNumber) {
            this.activeCash = "";
            this.cashId = "";
            let _this = this;
            CashManagementService.getCash(tourNumber).then(function (response) {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                }
                if (response.status != 200) {
                    let errorCode = Utils.getErrorCode(response);
                    if (errorCode) {
                        _this.setErrorMessage(
                            _this.$root.$t("error.error_code_" + errorCode)
                        );
                        _this.listCash = [];
                        _this.ownListCash = [];
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        _this.setErrorMessage("");
                        _this.listCash = response.data;
                        _this.ownListCash = _this.listCash.filter(item => item.key_name == _this.userCashKeyName);
                        _this.$forceUpdate();
                    } else {
                        _this.listCash = [];
                        _this.ownListCash = [];
                        _this.$forceUpdate();
                    }
                }
            });
        },
        getTourInfo (tourNumber, isClosed) {
            this.listCash = [];
            if (!tourNumber) {
                this.setErrorMessage("");
                return;
            }
            let _this = this;
            let patt = /^\d{6}-\d{3}$/;
            if (patt.test(tourNumber)) {
                TourManagementService.getTour(tourNumber, isClosed).then(function (
                    response
                ) {
                    if (response.status == 423) {
                        StorageService.saveExpired();
                        AuthService.doLogout();
                    } else if (response.status != 200) {
                        let errorCode = Utils.getErrorCode(response);
                        if (response.status == 404) {
                            _this.isNotTour = true;
                        } else {
                            _this.isNotTour = false;
                        }
                        if (errorCode) {
                            _this.setErrorMessage(
                                _this.$root.$t("error.error_code_" + errorCode)
                            );
                            _this.tourInfo = {};
                        }
                    } else {
                        if (!Utils.isEmptyObj(response.data)) {
                            _this.setErrorMessage("");
                            _this.tourInfo = response.data;
                            _this.getCashInfo(response.data.tour_number);
                        } else {
                            _this.setErrorMessage("");
                            _this.tourInfo = {};
                            // let msg = this.$root.$t("general.no_data");
                            // this.$toasted.success(msg, {});
                        }
                    }
                });
            } else {
                this.setErrorMessage(
                    this.$root.$t("error.error_code_13")
                );
            }
        },
        clickCash (cashId, index, name) {
            this.activeCash = index;
            this.cashId = cashId;
            StorageService.saveCashKeyName(this.listCash[index].key_name);
            StorageService.saveCashName(name);
            const developerName = this.listCash[index].developer_name;
            StorageService.saveDeveloperName(developerName);
        },
        toCashList () {
            if (this.cashId) {
                StorageService.saveCashId(this.cashId);
                // this.$router.push({path: '/cash/list-carry', query: {cashId: this.cashId}});
                this.$router.push({ path: "/voucher/list", query: {} });
            }
        },
        setErrorMessage (msg) {
            this.errorMessage = msg;
        },
        removeTourCash () {
            this.tourInfo = {};
            this.listCash = [];
            StorageService.removeTour();
        },
        updateSameTour () {
            this.getTourInfo(this.$route.query.search, this.$route.query.isClosed);
        },
        setIsClosed () {
            this.isClosed = 1;
            this.getTourInfo(this.$route.query.search, this.isClosed);
        },
    },
    watch: {
        $route (to, from) {
            this.removeTourCash();
            let tourNumber = this.$route.query.search;
            if (tourNumber) {
                this.getTourInfo(tourNumber, this.$route.query.isClosed);
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/components/pc/Tour/AfterInput.vue